import { flatten } from 'lodash';
import { transformSizeDto, transformSizeDtos } from './size';
export const transformSizeGroupDto = sizeGroup => {
  const {
    id,
    description,
    sizes
  } = sizeGroup;
  return {
    id,
    description,
    sizes: transformSizeDtos(sizes),
    faqEntryId: sizeGroup.faq_entry_id
  };
};
export const transformSizeGroupDtos = sizeGroups => ({
  sizeGroups: sizeGroups.map(transformSizeGroupDto),
  sizes: flatten(sizeGroups.map(sizeGroup => sizeGroup.sizes)).map(transformSizeDto)
});
export const transformSizeGroupModelToFilterGroupModel = sizeGroup => ({
  id: sizeGroup.id,
  description: sizeGroup.description,
  items: sizeGroup.sizes
});
export const transformSizeGroupModelsToFilterGroupModels = sizeGroups => sizeGroups.map(transformSizeGroupModelToFilterGroupModel);